import { assocPath, dissocPath } from "ramda"

export default function rootReducer(state = {}, action) {
  switch (action.type) {
    case "UPDATE_SESSION":
      const newSession = { ...state, ...action.updatedProperties }
      if (window.application?.attributes?.session) {
        window.application.attributes.session.attributes = newSession
      }
      return newSession
    case "UPDATE_DIVISIONCONFIGS":
      return assocPath(["divisionConfigs", action.key], action.value, state)
    case "SET_SESSION":
      return action.session
    case "UPDATE_PSA_TYPE": {
      window.psaConnect.set("psaType", action.psaType)
      return { ...state, psaType: action.psaType }
    }
    case "DELETE_SESSION_AUTHUSER":
      return dissocPath(["connect", "authUser"], state)
    default:
      return state
  }
}
